
import { PatientStatus } from "./types";

interface PatientStatusProps {
  previousGlp1: string;
  previousMedication: string;
  recentGlp1: string;
  selectedMedication: string;
}

export const usePatientStatus = ({
  previousGlp1,
  previousMedication,
  recentGlp1,
  selectedMedication,
}: PatientStatusProps): PatientStatus => {
  const isExistingPatient = previousGlp1 === "yes" && recentGlp1 === "yes";
  const isContinuingMedication = isExistingPatient && 
    previousMedication?.toLowerCase() === selectedMedication?.toLowerCase();

  // Calculate if patient qualifies for max dose based on their status
  const qualifiesForMaxDose = isContinuingMedication;

  return {
    isExistingPatient,
    isContinuingMedication,
    qualifiesForMaxDose
  };
};
